/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { socialProfileMatchedFactResponseDtoSchema } from "./socialProfileMatchedFactResponseDtoSchema";
import { z } from "zod/v4";

export const socialProfileCandidateResponseDtoSchema = z.object({
    "url": z.string(),
"profileName": z.string(),
get "matchedFacts"(){
                return z.array(socialProfileMatchedFactResponseDtoSchema)
              },
"nameAmbiguity": z.enum(["unique", "some_overlap", "very_common"])
    })